module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/09469790f10bcd5ed51fe8f85f8bdc1e.svg";